if(SCLayoutCollection === undefined) {
    function SCLayoutCollection() {
        this.vendors = []
    }

    var _SCLayoutCollection = {

        emit: function (name) {
            console.log("%c→ EMIT SCLayoutCollection." + name,"background:#1e98ec;color:#FFF")
            console.log({arguments})
            $(document).trigger('SCLayoutCollection.' + name, arguments);
        },

        _init: SCLayoutProducts.prototype.init,
        init: function () {
            this._init();
        }
    }

    //heritage de detail
    SCLayoutCollection.prototype = _.merge(SCLayoutProducts.prototype, _SCLayoutCollection);
    console.log("%cRENDER SC.layout-collection.js","background:yellow;color:#333")

}